import React, { useContext, useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    InputAdornment,
    InputLabel,
    Switch,
} from "@material-ui/core";

import Input from "@material-ui/core/Input";
import { useStores } from "../../../../../hooks";
import { MenuFormType } from "../../../store/menu/forms";
import { observer } from "mobx-react";
import { changeCheckboxEventHandlerDecorator, changeEventHandlerDecorator, localize } from "../../../../../common/libs";
import {
    DeliveryConditionType,
    DeliveryType,
    IDeliveryConditionsFixedPrice
} from "../../../../../services/menu/models";
import OrderSettingsPageStoreContext from "../context";
import { useTranslation } from "react-i18next";
import { Typography } from "../../../../../common/components/libs";


const EditDeliveryConditionsForm = () => {
    const {t} = useTranslation(["general", "menu"]);
    const [fixedPrice, setFixedPrice] = useState(0);
    const [fixedPriceToShow, setFixedPriceToShow] = useState("");

    const [freeDeliveryStartsFrom, setFreeDeliveryStartsFrom] = useState(0);
    const [freeDeliveryStartsFromToShow, setFreeDeliveryStartsFromToShow] = useState("");

    const [hasFreeDelivery, setHasFreeDelivery] = useState(true)

    const { constantsStore, generalStore } = useStores();

    const store = useContext(OrderSettingsPageStoreContext);
    const open = store.forms.editDeliveryConditions;
    const deliveryConditions = store.deliverySettings[DeliveryType.toAddress].deliveryConditions;
    const currencyFormatter = constantsStore.getCurrencyFormatter(generalStore.currency.id);

    useEffect(() => {
        if(!constantsStore.isReady) return;
        // TODO: replace during Yandex Delivery integration
        if(deliveryConditions.type !== DeliveryConditionType.fixedPrice) return;

        setFixedPrice(deliveryConditions.fixedDeliveryPrice.price);
        setFixedPriceToShow(currencyFormatter.toShow(deliveryConditions.fixedDeliveryPrice.price, true));

        setFreeDeliveryStartsFrom(deliveryConditions.freeDeliveryMinimalOrderPrice.price);
        setFreeDeliveryStartsFromToShow(
            currencyFormatter.toShow(deliveryConditions.freeDeliveryMinimalOrderPrice.price, true)
        );

        setHasFreeDelivery(deliveryConditions.freeDeliveryMinimalOrderPrice.price > 0);
    }, [deliveryConditions, constantsStore.isReady]);

    useEffect(() => {
        if(!hasFreeDelivery) setFreeDeliveryStartsFromWrapper('0');
    }, [hasFreeDelivery])


    const setFixedPriceWrapper = (value: string) => {
        setFixedPrice(currencyFormatter.toSend(currencyFormatter.toFloat(value)));
        setFixedPriceToShow(currencyFormatter.toStringFloat(value));
    };

    const setFreeDeliveryStartsFromWrapper = (value: string) => {
        setFreeDeliveryStartsFrom(currencyFormatter.toSend(currencyFormatter.toFloat(value)));
        setFreeDeliveryStartsFromToShow(currencyFormatter.toStringFloat(value));
    };


    const closeForm = () => {
        store.closeUpdateDeliveryConditionsForm();
    };

    const handleSubmit = async () => {
        if (deliveryConditions) {
            const data: IDeliveryConditionsFixedPrice = {
                fixedDeliveryPrice: {
                    currencyId: generalStore.currency.id,
                    price: fixedPrice
                },
                freeDeliveryMinimalOrderPrice: {
                    currencyId: generalStore.currency.id,
                    price: freeDeliveryStartsFrom
                },
                type: DeliveryConditionType.fixedPrice
            };
            store.setDeliveryToAddressSettings({
                description: localize(store.deliverySettings[DeliveryType.toAddress].description),
                deliveryConditions: data,
                isEnabled: store.deliverySettings[DeliveryType.toAddress].isEnabled,
            })
        }
        closeForm();
    };



    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:orderSettingsPage.deliverySettings")}
            </DialogTitle>
            <DialogContent>
                <form autoComplete="off">
                    <FormControl fullWidth>
                        <InputLabel>{t("menu:orderSettingsPage.deliveryPrice")}</InputLabel>
                        <Input
                            value={fixedPriceToShow}
                            onChange={changeEventHandlerDecorator(setFixedPriceWrapper)}
                            startAdornment={
                                <InputAdornment position="start"> ₽ </InputAdornment>
                            }
                            autoFocus={true}
                        />
                    </FormControl>
                    <br/>
                    <br/>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={hasFreeDelivery}
                                    onChange={changeCheckboxEventHandlerDecorator(setHasFreeDelivery)}
                                    value={hasFreeDelivery}
                                />
                            }
                            label={t("menu:orderSettingsPage.turnOnFreeDelivery")}
                        />
                    </FormControl>
                    <br/>
                    {hasFreeDelivery && <FormControl fullWidth>
                        <InputLabel>{t("menu:orderSettingsPage.minPriceToFreeDelivery")}</InputLabel>
                        <Input
                            value={freeDeliveryStartsFromToShow}
                            onChange={changeEventHandlerDecorator(setFreeDeliveryStartsFromWrapper)}
                            startAdornment={
                                <InputAdornment position="start"> ₽ </InputAdornment>
                            }
                        />
                    </FormControl>}

                </form>
            </DialogContent>

            <DialogActions>
                <Button onClick={closeForm} color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="primary"
                    onClick={handleSubmit}
                >
                    {t("general:save")}
                </Button>
            </DialogActions>
        </Dialog>
    );

};

export default observer(EditDeliveryConditionsForm);
